import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../Dialog';
import Button from '../Button';
import Checkbox from '../Checkbox';
import Table from '../Table';

export default function AditionalModuleDialog({
  openAditionalModuleDialog,
  setOpenAditionalModuleDialog,
  suppliersList = [],
  selectedModules = '',
  onSave
}) {
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // 🔹 Synchronizacja przy otwarciu dialogu lub zmianie danych
 useEffect(() => {
    if (!openAditionalModuleDialog) {
      setSelectedIds([]);
      setSelectAll(false);
      return;
    }

    // if (selectedSuppliers === '*') {
    //   setSelectedIds(suppliersList.map(s => String(s.id)));
    //   setSelectAll(true);
    // } else 
        if (selectedModules) {
      const ids = selectedModules.split(';').map(String);
      setSelectedIds(ids);
      setSelectAll(ids.length === suppliersList.length);
    } else {
      setSelectedIds([]);
      setSelectAll(false);
    }
  }, [openAditionalModuleDialog, selectedModules, suppliersList]);
  // 🔹 Toggle pojedynczego dostawcy
    const toggleSupplier = (id) => {
    setSelectedIds(prev => {
      const newSelected = prev.includes(String(id))
        ? prev.filter(x => x !== String(id))
        : [...prev, String(id)];

      setSelectAll(newSelected.length === suppliersList.length);
      return newSelected;
    });
  };

  // 🔹 Toggle wszystkich
  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
      setSelectAll(false);
    } else {
      setSelectedIds(suppliersList.map(s => String(s.id)));
      setSelectAll(true);
    }
  };

  // 🔹 Zapis
   const handleSave = () => {
    const result = selectedIds.join(';');
    onSave(result);
    setOpenAditionalModuleDialog(false);
  };

  // 🔹 Kolumny tabeli
  const columns = [
    {
      field: 'select',
      headerName: '',
      width: 40,
      renderCell: ({ row }) => (
        <Checkbox
        checked={selectedIds.includes(String(row.id))}
            onCheckedChange={() => toggleSupplier(row.id)}
          size="small"
        />
      ),
    },
    {
      field: 'access_Name',
      headerName: 'Nazwa',
      renderCell: ({ row }) => (
        <div
          onClick={() => toggleSupplier(row.id)}
          className="cursor-pointer select-none hover:text-primary-600 transition-colors"
        >
          {row.access_Name}
        </div>
      ),
    },
     {
      field: 'description',
      headerName: 'Opis',
      renderCell: ({ row }) => (
        <div
          onClick={() => toggleSupplier(row.id)}
          className=" cursor-pointer
        select-none
        hover:text-primary-600
        transition-colors
        whitespace-normal
        break-words"
        >
          {row.description}
        </div>
      ),
    }
   
  ];

  return (
    <Dialog
      open={openAditionalModuleDialog}
      onClose={() => setOpenAditionalModuleDialog(false)}
      maxWidth="md"
    >
      <DialogTitle>Dodatkowe moduły dla konta</DialogTitle>
      <DialogContent className="overflow-y-auto max-h-[70vh]">
        <div className="overflow-x-auto mt-2">
    

          {/* 🔹 Tabela dostawców */}
          <Table columns={columns} data={suppliersList} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          size="medium"
          variant="outlined"
          onClick={() => setOpenAditionalModuleDialog(false)}
        >
          Anuluj
        </Button>
        <Button
          size="medium"
          variant="contained"
          color="success"
          onClick={handleSave}
        >
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
}



///zmien dane zaznaczone w tabeli 